import * as yup from 'yup'

export const UploadModalSchema = yup.object().shape({
  secret_phrase: yup
    .string()
    .required(
      'Encryption key is required',
    )
})